import { Grid, IconButton, Paper } from '@mui/material';
import CardHeader from '../../components/Card/CardHeader';
import Card from '../../components/Card/Card';
import { useParams } from 'react-router-dom';
import MotiveConnector from './connectors/Motive/motive';
import { Cancel } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import BusinessCentralConnector from './connectors/businessCentral/BusinessCentral';
import McpConnector from './connectors/MCP/mcp';

interface IntegrationParams {
  integrationName: string;
}
export default function IntegrationConnectPage() {
  const { integrationName } = useParams<IntegrationParams>();
  const [connectorInfo, setConnectorInfo] = useState<any>();

  useEffect(() => {
    switch (integrationName) {
      case 'motive':
        setConnectorInfo({ name: 'motive', displayName: ' Connect to Motive' });
        break;
      case 'businessCentral':
        setConnectorInfo({
          name: 'businessCentral',
          displayName: ' Connect to Microsoft Dynamics 365 Business Central',
        });
        break;
      case 'MCP':
        setConnectorInfo({ name: 'mcp', displayName: 'Enable MCP Server access' });
        break;
      default:
        setConnectorInfo(undefined);
    }
  }, [integrationName]);

  function cancelConnect(): void {
    location.href = '/settings/integrations';
  }

  return (
    <Card>
      <CardHeader color="primary">
        <Grid container>
          <Grid item flexGrow={1}>
            {connectorInfo?.displayName}
          </Grid>
          <Grid item>
            <IconButton size="small" onClick={cancelConnect}>
              <Cancel style={{ color: 'white' }} />
            </IconButton>
          </Grid>
        </Grid>
      </CardHeader>
      <Paper>
        <Grid container p={2}>
          {connectorInfo?.name === 'motive' && <MotiveConnector afterDisconnect={cancelConnect} />}
          {connectorInfo?.name === 'businessCentral' && <BusinessCentralConnector afterDisconnect={cancelConnect} />}
          {connectorInfo?.name === 'mcp' && <McpConnector afterDisconnect={cancelConnect} />}
        </Grid>
      </Paper>
    </Card>
  );
}
